module.exports = "/_next/static/images/zcash-1edf4f3047692736b613e24e09108124.png";